import { graphql } from "react-relay";
import { ChromeDay } from "./ChromeDay";

export const queries = graphql`
  query ChromeDayRendererQuery(
    $calendarIds: [String!]!
    $dates: [LocalDate!]!
    $weekStartDates: [LocalDate!]!
    $timeZone: String!
  ) {
    viewer {
      ...ChromeDay_viewer
        @arguments(
          calendarIds: $calendarIds
          dates: $dates
          weekStartDates: $weekStartDates
          timeZone: $timeZone
        )
    }
  }
`;
